<div class="container-fluid mt-5">
  <div class="row">
    <div class="col-xl-4">
      <div class="rounded-tile background-light-blue">
        <div class="row">
          <div class="col-lg-8">
            <h2>{{ data.callToAction?.text }}</h2>
          </div>
          <div class="col-lg-4 position-relative">
            <a
              href="{{ data.callToAction?.url }}"
              target="{{
                data.callToAction?.openInNewTab ? '_blank' : '_self'
              }}"
              class="btn-arrow"
            >
              
                <i class="fa-duotone fa-solid fa-circle-arrow-right fa-duotone-custom-colors"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-8 d-flex">
      <div class="rounded-tile background-gray countdown-timer-box">
        <div class="countdown-timer">
          <div class="row">
            <div class="col-12 col-md">
              <div class="count-down-unit">{{ countdown().days }}</div>
              <div class="countdown-unit-title">{{ countdown().days === 1 ? 'dag' : 'dagen' }}</div>
            </div>
            <div class="col-12 col-md">
              <div class="count-down-unit">{{ countdown().hours }}</div>
              <div class="countdown-unit-title">{{ countdown().hours === 1 ? 'uur' : 'uren' }}</div>
            </div>
            <div class="col-12 col-md">
              <div class="count-down-unit">{{ countdown().minutes }}</div>
              <div class="countdown-unit-title">{{ countdown().minutes === 1 ? 'minuut' : 'minuten' }}</div>
            </div>
            <div class="col-12 col-md">
              <div class="count-down-unit">{{ countdown().seconds }}</div>
              <div class="countdown-unit-title">{{ countdown().seconds === 1 ? 'seconde' : 'seconden' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
